import { LeadFilters } from 'lib/api/leadOpportunities/types';
import { defaultLeadTypeOption } from 'lib/const/leads';

export const formatFilters = (filters: {
  [key: string]: { value: string; label: string }[];
}): LeadFilters => ({
  ...(!!filters?.leadStatus?.length
    ? { leadStatus: filters.leadStatus.map(item => item.value) }
    : {}),
  ...(!!filters?.leadStatusType?.length
    ? { leadStatusType: filters.leadStatusType.map(item => item.value) }
    : {}),
  ...(!!filters?.leadType?.length
    ? { leadType: filters.leadType.map(item => item.value) }
    : {}),
  ...(!!filters?.leadGroupCategory?.length
    ? { leadGroupCategory: filters.leadGroupCategory.map(item => item.value) }
    : {}),
  ...(!!filters?.leadSource?.length
    ? { leadSource: filters.leadSource.map(item => item.value) }
    : {}),
  ...(!!filters?.isHot?.length
    ? { isHot: filters.isHot.map(item => item.value) }
    : {}),
});

const LEAD_REPORTS_FILTERS = 'LEAD_REPORTS_FILTERS';

export const getDropdownSelectionsByUserId = (
  userId: string
): Record<string, { value: string; label: string }[]> => {
  try {
    const stored = localStorage.getItem(LEAD_REPORTS_FILTERS);
    if (!stored) return defaultLeadTypeOption;

    const parsed = JSON.parse(stored);
    return parsed[userId] || defaultLeadTypeOption;
  } catch (error) {
    console.error(
      'Failed to parse dropdownSelections from localStorage:',
      error
    );
    return {};
  }
};

export const saveDropdownSelectionsByUserId = (
  userId: string,
  selections: Record<string, { value: string; label: string }[]>
) => {
  try {
    const existing = JSON.parse(
      localStorage.getItem(LEAD_REPORTS_FILTERS) || '{}'
    );
    const updatedWithUser = {
      ...existing,
      [userId]: selections,
    };
    localStorage.setItem(LEAD_REPORTS_FILTERS, JSON.stringify(updatedWithUser));
  } catch (error) {
    console.error('Failed to save dropdown selections:', error);
  }
};
